import { createStyles }     from "@mantine/core";
import { maxWidth }         from "_common/utils";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		rightSideBarContainer: {
			display       : "flex",
			flexDirection : "column",
			alignItems    : "flex-start",
			position      : "sticky",
			top           : "70px",
			flex          : "1",
			maxWidth      : "345px",
			minWidth      : "345px"
		},
		rightSideBarContainerLive: {
			display         : "flex",
			flexDirection   : "column",
			alignItems      : "flex-start",
			position        : "sticky",
			height          : props?.theatreModeToggle ? "100vh" : "calc(100vh - 70px)",
			top             : props?.theatreModeToggle ? "0" : "70px",
			flex            : "1",
			maxWidth        : "25vw",
			// borderLeft      : `1px solid ${ theme.other.colors.border.primary }`,
			backgroundColor : "inherit"
		},
		scrollContainer: {
			height   : !props?.theatreModeToggle ? "100%" : "calc(100vh)",
			overflow : "hidden",
			width    : "100%"
		},
		childMainContainer: {
			display     : "flex",
			marginTop   : !props?.theatreModeToggle ? "70px" : "0",
			paddingLeft : !props?.theatreModeToggle ? "6rem" : "0",

			[rooterMediaQuery.tablet]: {
				paddingLeft: !props?.theatreModeToggle ? "6rem" : "0"
			},

			[rooterMediaQuery.mobile]: {
				paddingLeft: 0
			},

			[theme.fn.largerThan ( maxWidth )]: {
				maxWidth : maxWidth + "px",
				margin   : "auto"
			}

		},
		childContainer: {
			width: "100%"
		},
		footerContianer: {
			paddingLeft: "6rem"
		},
		creatorDashLayout: {
			display   : "flex",
			marginTop : "70px",
			overflow  : "hidden"
		},
		creatorDashMobileLayout: {
			display       : "flex",
			flexDirection : "column",
			marginTop     : "70px",
			paddingBottom : "4.5rem",
			height        : "calc(100vh - 70px)"
		}
	};
} );
